import AddAdminMemoModal from './AddAdminMemoModal';

export default AddAdminMemoModal;
